import { axios } from "../api/axios";
import { axiosV2 } from "../api/axios"

export const startRecordAPI = (data : any, presenterNum: number) => {
  return axiosV2.post("/record/start", {
    ...data,
    presenterNum: presenterNum
  });
};

export const updateRecord = (uid: number | null) => {
  return axiosV2.put("/record/update", {
    uid: uid
  });
};

export const settingRecord = () => {
  return axios.get("/remote/live_videos/add.json");
};

export const stopRecordAPI = () => {
  return axiosV2.post("/record/stop");
};

export const uploadThumbnail = (uploadData:any, data:any) => {
  return axios.put(uploadData.upload_url, data, {
    headers: {
      "Content-Type": uploadData.upload_content_type,
    },
  });
};

export const saveInteractionAPI = (streamId: string, data: any) => {
  data.map((item:any) => {
    if (item.interaction_type === "shop_com") {
      item.interaction_type = 'media';
      item.sub_type = 'other';
      item.real_type = 'shop_com';
    }

    if (item?.attributes?.siteName === "Trannont") {
      item.interaction_type = 'media';
      item.sub_type = 'other';
      item.real_type = 'tranont';
    }

    if (item?.attributes?.siteName === "partner.co") {
      item.interaction_type = 'media';
      item.sub_type = 'other';
      item.real_type = 'partner.co';
    }
  });
  const dataNew = {
      interactions: [
          ...data
      ],
      schema_version: 3
  }
return axios.post(`stream/interactions/record/${streamId}`,dataNew);
};

export const getPreviousInteractions = (streamId: string) => {
  return axios.get(`stream/interactions/record/${streamId}`);
}